import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const descriptions = {
  External:
    "We do external work such as masonry works, structural steelworks and groundwork.",
  Internal:
    "We are experts at doing all manner of mixed trade internal work including joinery, CCTV and door access systems.",
}

const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

class PortfolioSummaryTemplate extends React.Component {
  render() {
    const { data } = this.props
    const { edges: images } = data.allFile

    return (
      <section class="wrapper">
        <div class="inner">
          <header class="major">
            <h2>Past Projects</h2>
            <p>
              You can use the below links to view some examples of our past
              work. These include before and after photographs across a wide
              range of services.
            </p>
          </header>
          <div className="posts">
            {images &&
              images.map(({ node: image }) => (
                <section key={image.name} className="post">
                  <a href="#" class="image">
                    <Img
                      fluid={image.childImageSharp.fluid}
                      alt={image.name}
                      title={image.name}
                    />
                  </a>
                  <div className="content">
                    <h3>{capitalizeFirstLetter(image.name)} Work</h3>
                    <p>{descriptions[image.name]}</p>
                  </div>
                  <Link
                    to={`portfolio/${image.name.toLowerCase()}`}
                    className="button"
                  >
                    More
                  </Link>
                </section>
              ))}
          </div>
        </div>
      </section>
    )
  }
}

const PortfolioSummary = () => (
  <StaticQuery
    query={graphql`
      query PortfolioSummaryImagesQuery {
        allFile(
          filter: {
            extension: { in: ["jpg", "png"] }
            relativeDirectory: { eq: "portfolio" }
          }
        ) {
          edges {
            node {
              name
              relativePath
              childImageSharp {
                fluid(maxWidth: 202, maxHeight: 199) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => <PortfolioSummaryTemplate data={data} />}
  />
)

export default PortfolioSummary
